


















































import { defineComponent, ref, useContext, useFetch } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import MarketingCard from './MarketingCard.vue';
import { getAxiosConfigs } from '~/utils/solepro/functions';
import axios from 'axios';
import { merge } from 'lodash-es';
import { useConfig } from '~/composables';
import { ProductForProductPageType } from '~/utils/types/ProductPage';
import { getFirstPriceLabel, getSecondPriceLabel } from '~/utils/helpers/product';

import { Pagination, Navigation } from 'swiper'
import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'
import ConfigureBundle from '../../ProductPage/PurchaseOptions/ConfigureBundle.vue';
import useLoader from '~/composables/useLoader';
SwiperCore.use([Pagination, Navigation])

export default defineComponent({
    props: {
        node: {
            type: Object as PropType<ProductForProductPageType>,
            required: true
        },
    },
    components: {
        MarketingCard,
        ConfigureBundle,
        Swiper, SwiperSlide
    },
    setup(props) {

        const { node: content } = props as Readonly<{ [key: string]: any }>;
        const { app, $fc } = useContext();
        const { setIsLoading } = useLoader()
        const products = ref<ProductForProductPageType[] | []>([]);
        const { config } = useConfig();
        const useCarousel = ref(false)
        const titleCentered = ref(false)
        const paymentFrequenciesChoosen = ref({});
        const swiperProps = {
            modules: [Navigation, Pagination],
            slideClass: "slide",
            navigation: {
                prevEl: '.section-purchase-options .navigation-prev',
                nextEl: '.section-purchase-options .navigation-next',
            },
            slidesPerView: 'auto',
            slidesPerGroup: 3,
            direction: "horizontal",
            spaceBetween: 20,
        }
        setIsLoading(true)
        useFetch(async () => {
            const { data } = await axios.post(`/sole-api/product/pro/getPacchetti`, { skus: content.skus }, { ...getAxiosConfigs(app, config) });
            products.value = merge(data as ProductForProductPageType[]);
            data.forEach(product => {
                paymentFrequenciesChoosen.value[product.sku] = product.entryBillingPeriod ?? product.paymentFrequencies[product.paymentFrequencies.length - 1]
            })
            titleCentered.value = products.value.length < 3;
            setIsLoading(false)
            if (window) {
                useCarousel.value = products.value.length > 3 && window.innerWidth >= 1024;
            }

        })
        return {
            products,
            useCarousel,
            swiperProps,
            titleCentered,
            paymentFrequenciesChoosen,
            i18n: app.i18n, fc: $fc
        }
    },
    methods: {
        handleResize() {
            this.useCarousel = this.products.length > 3 && window.innerWidth >= 1024;
        },
        calculateHeights(swiper) {
            const slides = swiper.$el[0].querySelectorAll('.slide');
            const tallest = Array.from(slides).reduce((tallest: Element, slide: Element) => {
                return slide.querySelector('.solepro-option-card').getBoundingClientRect().height > tallest.querySelector('.solepro-option-card').getBoundingClientRect().height ? slide : tallest;
            });
            const h = (tallest as HTMLElement).offsetHeight + 'px';
            slides.forEach(el => el.querySelector('.solepro-option-card').style.height = h)
        },
        afterInit(swiper) {
            const interval = setInterval(() => {
                //const slides = swiper.$el[0].querySelectorAll('.slide');
                const slides = swiper.slides;
                if (slides.length > 1) {
                    clearInterval(interval);
                    swiper.update();
                    console.log('updated');
                    this.calculateHeights(swiper)
                }
            }, 100)
            setTimeout(() => {
                clearInterval(interval)
            }, 5000)
        },
        getFirstPriceLabelProp(product) {
            return getFirstPriceLabel(product, this.paymentFrequenciesChoosen[product.sku], this.i18n, this.fc)
        },
        getSecondPriceLabelProp(product) {
            return getSecondPriceLabel(product, this.paymentFrequenciesChoosen[product.sku], this.i18n, this.fc)
        },
        changeFrequency(product, val) {
            this.paymentFrequenciesChoosen[product.sku] = val;
            this.$forceUpdate()
        }
    },
    mounted() {
        this.useCarousel = this.products.length > 3 && window.innerWidth >= 1024;
        window.addEventListener('resize', this.handleResize)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize)
    }

})
